import React from 'react'
import { FormInputAddress } from '../../../../../../../ui/organisms'
import { ProjectAddressInput } from '../../../../../../../ui/organisms/builder-2.0/ProjectAddressInput'
import { addressView } from '../../../../../../../utils/helpers/addressView'


export default {
    title: 'What is the address of the project you’re purchasing materials for?',
    next: 'projectInfo.projectType',
    view: addressView,
    component: ProjectAddressInput,
  }
  